export function clamp (val, min = 0, max = Number.MAX_VALUE) {
  return Math.min(Math.max(val, min), max)
}

export function clamp01 (val) {
  return clamp(val, 0, 1)
}
